import Vue from 'vue';
import VueCompositionApi from '@vue/composition-api';
import firebaseAuthPlugin from '@/plugins/firebaseAuth';

Vue.use(VueCompositionApi);
Vue.use(firebaseAuthPlugin);
